"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SelectInputGroupAddon = require("./SelectInputGroupAddon");
Object.keys(_SelectInputGroupAddon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectInputGroupAddon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SelectInputGroupAddon[key];
    }
  });
});